/* eslint-disable */
import { useState } from "react";

const EventListFilterPopup = ({ setFilterDate }) => {
  const [eventDate, setEventDate] = useState("");

  const searchHandler = () => {
    setFilterDate(eventDate);

    // close the offcanvas of filter
    let offCanvasPopup = document.querySelector("#offcanvasRight");
    let offCanvas = bootstrap.Offcanvas.getInstance(offCanvasPopup);
    offCanvas.hide();
  };
  return (
    <div className="offcanvas_sidebar">
      <div
        className="offcanvas offcanvas-end body_bg"
        tabIndex="-1"
        id="offcanvasRight"
        aria-labelledby="offcanvasTopLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="close-btn text-reset filter_cross d-flex align-items-center justify-content-center"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <span className="material-icons-outlined">close</span>
          </button>
        </div>
        <div className="offcanvas-body">
          {/* <div className="posted_check_row d-flex align-items-center justify-content-between mb-3">
            <h4 className="fw-medium text-primary fs-sm">Posted by You</h4>
            <label className="radio-check">
              <input type="checkbox" />
              <span></span>
            </label>
          </div> */}
          <div className="filter_outerbx">
            {/* <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Ecosystem</h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="filter_info">
                <div className="filter_list department_info">
                  <ul className="list_style_none d-flex gap-2 flex-wrap">
                    <li>All Ecosystem</li>
                    <li>Indra</li>
                    <li className="active">Findelit</li>
                    <li>Lobees</li>
                    <li>SportsMoon</li>
                    <li>Crowcol</li>
                    <li>Enaire</li>
                    <li>Saludti</li>
                    <li>FindelDron</li>
                  </ul>
                </div>
              </div>
            </div> */}
            {/* <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">Winner</h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="filter_info">
                <div className="filter_list department_info">
                  <ul className="list_style_none d-flex gap-2 flex-wrap">
                    <li className="active">All</li>
                    <li>Winner Selected</li>
                    <li>Not Selected</li>
                  </ul>
                </div>
              </div>
            </div> */}

            {/* date search */}
            <div className="product_filtr_item mb-3">
              <div className="filter_hdng d-flex align-items-center justify-content-between mb-3">
                <div className="filter_name">
                  <h4 className="fs-sm fw-medium text-primary">
                    Search by date
                  </h4>
                </div>
                <span className="accor_arw">
                  <i className="material-icons-outlined">
                    {" "}
                    keyboard_arrow_down
                  </i>
                </span>
              </div>
              <div className="price_range d-flex gap-2">
                <div className="price_fill">
                  <input
                    type="date"
                    className="form-control"
                    placeholder="From"
                    value={eventDate}
                    onChange={(e) => setEventDate(e.target.value)}
                  />
                </div>

                <div className="go_btn" onClick={searchHandler}>
                  <button type="button" className="go_price btn primary-btn">
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventListFilterPopup;
